import { Link } from "react-router";
import { Table, type TableProps } from "antd";
import { useEffect, useState } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import ConfirmModal from "../../components/modal/ConfirmModal";
import ButtonIcon from "../../components/ButtonIcon";
import StatusVisit from "../../components/StatusVisit";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import { $api, type components } from "../../helper";
import { statusMock, tokenMock } from "../../helper/mock";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { useNotify } from "../../helper/notify";
import FilterSearch from "../../components/filter/FilterSearch";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function TicketCategory() {
  const notify = useNotify();
  const categoryList = $api.useQuery("get", "/site-api/v1/ticket/category/", {
    headers: {
      Authorization: tokenMock,
      lang: "fa",
    },
  });
  const { mutate, isPending } = $api.useMutation(
    "delete",
    "/site-api/v1/ticket/category/",
  );
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState({
    u_id: "",
    title: "",
  });
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("دسته بندی تیکت");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteTicketCategoryItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "عنوان دسته بندی",
      dataIndex: "title",
      key: "title",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.title
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "نمایش در سایت",
      key: "show",
      dataIndex: "show",
      filters: statusMock,
      onFilter: (value, record) =>
        record.status.toString().indexOf(value as string) === 0,
      render: (_, record) => <StatusVisit status={record.status} />,
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonLinkIcon
            to={{
              pathname: "/add-ticket-category",
              search: "?u_id=" + record.u_id,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: "/add-ticket-category",
              search: "?u_id=" + record.u_id,
            }}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setId({ title: record.title, u_id: record.u_id });
              setIsOpen(true);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId({ title: record.title, u_id: record.u_id });
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={isPending}
        title="حذف از دسته بندی ها ؟"
        description="حذف این دسته‌بندی باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          mutate(
            {
              params: {
                query: {
                  category_u_id: id.u_id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setId({ title: "", u_id: "" });
                setIsOpen(false);
                categoryList.refetch();
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => {
          setId({ title: "", u_id: "" });
          setIsOpen(false);
        }}
      />
      <div className="w-full flex justify-end sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <Link to={"/add-ticket-category"} className="button-style">
          ایجاد دسته بندی
        </Link>
      </div>

      <BaseCard props={{ className: "flex-1 w-full flex-col flex gap-6" }}>
        <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
          <Table<components["schemas"]["SiteTicketCategoryItem"]>
            columns={columns}
            className="col-span-1!"
            scroll={{ x: "max-content" }}
            dataSource={categoryList.data?.data}
          />
        </BaseTable>
      </BaseCard>
    </div>
  );
}
